
function setPrice() {
    let price = document.querySelectorAll('.nm-easywholesale-price ')
    let subtotal = 0
    let isCP = false
    if (price.length) {
        price.forEach((e) => {
            let variantID = e.getAttribute('data-priceid')
            let price_container = document.querySelector('.nm-wholesale-table-container')
            let productId = price_container.getAttribute('data-productid')
            let variant = BSS_B2B.storage.variantStorage.get(Number(variantID))
            let input = document.querySelector(`input[data-id='nm-${variantID}']`)
            let quantity = Number(input?.value)
            if (variant && variant.bssB2BPriceAfterCP) {
                isCP = true
                subtotal = subtotal + (variant.bssB2BPriceAfterCP*quantity)
            } else {
                subtotal = subtotal + (variant.price*quantity)
            }
        })
    }
  if (isCP) {
   
    let subTotalEle = document.querySelector('.nm-easywholesale-total')
    subTotalEle.innerHTML = BSS_B2B.formatMoney(subtotal)
  

  }
    console.log(subtotal)
}

document.addEventListener("DOMContentLoaded", function() {
    let price = document.querySelectorAll('.nm-easywholesale-price ')
    if (price.length) {
        price.forEach((e) => {
            let variantID = e.getAttribute('data-priceid')
            let price_container = document.querySelector('.nm-wholesale-table-container')
            let productId = price_container.getAttribute('data-productid')
            e.setAttribute('bss-b2b-product-id', productId)
            e.setAttribute('bss-b2b-product-price', '')
            e.setAttribute('bss-b2b-variant-id', variantID)
            e.setAttribute('bss-b2b-variant-price', '')
        })
        let totalPrice = document.querySelector('.nm-easywholesale-total')
        let priceInput = document.querySelectorAll('input.nm-easywholesale-qty ');
        priceInput.forEach((e) => {
            e.addEventListener('change', () => {
               setPrice()
            })
        })
        let priceVariantClick = document.querySelectorAll('.nm-easywholesale-qty-decrease ,.nm-easywholesale-qty-increase ');
        priceVariantClick.forEach((e) => {
            e.addEventListener('click', () => {
                setPrice()
            })
        });
    }



});

